import moment from 'moment';

export const getTodayDate = (format = 'DD.MM.YYYY') => {
  return moment().format(format);
};

export const getYesterdayDate = () => {
  return moment()
    .subtract(1, 'day')
    .format('DD.MM.YYYY');
};

export const timeFromNow = date => {
  const timestamp = moment(date).format('X');
  const newDate = moment.unix(timestamp);
  return moment(newDate).fromNow();
};

export const isToday = date => {
  return moment().isSame(date, 'day');
};

export const getNewDate = (noOfDays, format = 'DD MMM, YYYY') => {
  return moment()
    .add(noOfDays, 'days')
    .format(format);
};

export const getDateElements = date => {
  const dateString = moment(date).format('dddd, MMMM DD YYYY, hh:mm A');
  const dateSections = dateString.split(',');
  const day = dateSections[0];
  const time = dateSections[2];
  const datePart = dateSections[1].trim().split(' ');
  return {
    day,
    time,
    date: {
      dateString: dateSections[1],
      month: datePart[0],
      date: datePart[1],
      year: datePart[2],
    },
  };
};

export const getTime = date => {
  const dateObj = moment(date, 'dddd, MMMM DD YYYY, hh:mm a');
  return moment(dateObj).format('LT');
};

export const isDatesSame = (dateA, dateB) => {
  return moment(dateA).isSame(dateB, 'day');
};

export const isDateAfter = date => {
  const todayDate = getTodayDate('dddd, MMMM DD YYYY, hh:mm a');
  return moment(todayDate).isAfter(date);
};

export const getDateinDesiredFormat = (date, format) => {
  return moment(date).format(format);
};

export const makeJSDateObject = date => {
  if (date) {
    return new Date(date.getTime());
  }
  return date;
};

/**
 * Get Formatted Date
 * @param date
 * @param format
 * @returns {string}
 */
export const getFormattedDate = (date, format = 'YYYY-MM-DD') => {
  if (moment(date, 'YYYY-MM-DD').isValid()) {
    return moment(date).format(format);
  }

  return '';
};

/**
 * Check Is dateTime of Tomorrow
 * @param inputDateTime
 * @returns {boolean}
 */
export const isTomorrow = inputDateTime => {
  const tomorrow = moment()
    .add(1, 'days')
    .format('YYYY-MM-DD');

  return moment(inputDateTime).isSame(tomorrow, 'day');
};

/**
 * Check Is dateTime of Yesterday
 * @param inputDateTime
 * @returns {boolean}
 */
export const isYesterday = inputDateTime => {
  const yesterday = moment()
    .subtract(1, 'days')
    .format('YYYY-MM-DD');

  return moment(inputDateTime).isSame(yesterday, 'day');
};

/**
 * Get Custom Date Time
 * @param value
 * @param unit
 * @param format
 * @returns {string}
 */
export const getCustomDateTime = (value = 0, unit = 'days', format = 'YYYY-MM-DD') => {
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment()
      .add(value, unit)
      .format(format);
  }
};

export const getDateText = date => {
  if (isToday(date)) {
    return 'Today';
  } else if (isYesterday(date)) {
    return 'Yesterday';
  } else if (isTomorrow(date)) {
    return 'Tomorrow';
  } else {
    return date;
  }
};

export const getTimeDiffString = date => {
  const postDate = moment(date, 'ddd MMM DD YYYY kk:mm:ss Z');
  const currentDate = moment(new Date());
  const duration = moment.duration(currentDate.diff(postDate));
  const minutes = duration.asMinutes() | 0;
  const hours = duration.asHours() | 0;

  switch (true) {
    case minutes === 0:
      return 'Just now';
    case minutes < 60:
      return `${minutes} min`;
    case hours < 24:
      return `${hours} hours`;
    default:
      return postDate.format('DD MMM, YYYY');
  }
};

export const WBPCountries = [
  { id: '1', abbrv: 'AF', name: 'Afghanistan' },
  { id: '2', abbrv: 'AL', name: 'Albania' },
  { id: '3', abbrv: 'DZ', name: 'Algeria' },
  { id: '4', abbrv: 'AS', name: 'American Samoa' },
  { id: '5', abbrv: 'AD', name: 'Andorra' },
  { id: '6', abbrv: 'AO', name: 'Angola' },
  { id: '7', abbrv: 'AI', name: 'Anguilla' },
  { id: '8', abbrv: 'AQ', name: 'Antarctica' },
  { id: '9', abbrv: 'AG', name: 'Antigua and Barbuda' },
  { id: '10', abbrv: 'AR', name: 'Argentina' },
  { id: '11', abbrv: 'AM', name: 'Armenia' },
  { id: '12', abbrv: 'AW', name: 'Aruba' },
  { id: '13', abbrv: 'AU', name: 'Australia' },
  { id: '14', abbrv: 'AT', name: 'Austria' },
  { id: '15', abbrv: 'AZ', name: 'Azerbaijan' },
  { id: '16', abbrv: 'BS', name: 'Bahamas' },
  { id: '17', abbrv: 'BH', name: 'Bahrain' },
  { id: '18', abbrv: 'BD', name: 'Bangladesh' },
  { id: '19', abbrv: 'BB', name: 'Barbados' },
  { id: '20', abbrv: 'BY', name: 'Belarus' },
  { id: '21', abbrv: 'BE', name: 'Belgium' },
  { id: '22', abbrv: 'BZ', name: 'Belize' },
  { id: '23', abbrv: 'BJ', name: 'Benin' },
  { id: '24', abbrv: 'BM', name: 'Bermuda' },
  { id: '25', abbrv: 'BT', name: 'Bhutan' },
  { id: '26', abbrv: 'BO', name: 'Bolivia' },
  { id: '27', abbrv: 'BA', name: 'Bosnia and Herzegowina' },
  { id: '28', abbrv: 'BW', name: 'Botswana' },
  { id: '29', abbrv: 'BV', name: 'Bouvet Island' },
  { id: '30', abbrv: 'BR', name: 'Brazil' },
  { id: '31', abbrv: 'IO', name: 'British Indian Ocean Territory' },
  { id: '32', abbrv: 'VG', name: 'British Virgin Islands' },
  { id: '33', abbrv: 'BN', name: 'Brunei Darussalam' },
  { id: '34', abbrv: 'BG', name: 'Bulgaria' },
  { id: '35', abbrv: 'BF', name: 'Burkina Faso' },
  { id: '36', abbrv: 'BI', name: 'Burundi' },
  { id: '37', abbrv: 'KH', name: 'Cambodia' },
  { id: '38', abbrv: 'CM', name: 'Cameroon' },
  { id: '39', abbrv: 'CA', name: 'Canada' },
  { id: '40', abbrv: 'CV', name: 'Cape Verde' },
  { id: '41', abbrv: 'KY', name: 'Cayman Islands' },
  { id: '42', abbrv: 'CF', name: 'Central African Republic' },
  { id: '43', abbrv: 'TD', name: 'Chad' },
  { id: '44', abbrv: 'CL', name: 'Chile' },
  { id: '45', abbrv: 'CN', name: 'China' },
  { id: '46', abbrv: 'CX', name: 'Christmas Island' },
  { id: '47', abbrv: 'CC', name: 'Cocos (Keeling) Islands' },
  { id: '48', abbrv: 'CO', name: 'Colombia' },
  { id: '49', abbrv: 'KM', name: 'Comoros' },
  { id: '50', abbrv: 'CG', name: 'Congo' },
  { id: '51', abbrv: 'CK', name: 'Cook Islands' },
  { id: '52', abbrv: 'CR', name: 'Costa Rica' },
  { id: '53', abbrv: 'CI', name: "Cote D'ivoire" },
  { id: '54', abbrv: 'HR', name: 'Croatia' },
  { id: '55', abbrv: 'CU', name: 'Cuba' },
  { id: '56', abbrv: 'CY', name: 'Cyprus' },
  { id: '57', abbrv: 'CZ', name: 'Czech Republic' },
  { id: '58', abbrv: 'DK', name: 'Denmark' },
  { id: '59', abbrv: 'DJ', name: 'Djibouti' },
  { id: '60', abbrv: 'DM', name: 'Dominica' },
  { id: '61', abbrv: 'DO', name: 'Dominican Republic' },
  { id: '62', abbrv: 'TP', name: 'East Timor' },
  { id: '63', abbrv: 'EC', name: 'Ecuador' },
  { id: '64', abbrv: 'EG', name: 'Egypt' },
  { id: '65', abbrv: 'SV', name: 'El Salvador' },
  { id: '66', abbrv: 'GQ', name: 'Equatorial Guinea' },
  { id: '67', abbrv: 'ER', name: 'Eritrea' },
  { id: '68', abbrv: 'EE', name: 'Estonia' },
  { id: '69', abbrv: 'ET', name: 'Ethiopia' },
  { id: '70', abbrv: 'FK', name: 'Falkland Islands (Malvinas)' },
  { id: '71', abbrv: 'FO', name: 'Faroe Islands' },
  { id: '72', abbrv: 'FJ', name: 'Fiji' },
  { id: '73', abbrv: 'FI', name: 'Finland' },
  { id: '74', abbrv: 'FR', name: 'France' },
  { id: '75', abbrv: 'GF', name: 'French Guiana' },
  { id: '76', abbrv: 'PF', name: 'French Polynesia' },
  { id: '77', abbrv: 'TF', name: 'French Southern Territories' },
  { id: '78', abbrv: 'GA', name: 'Gabon' },
  { id: '79', abbrv: 'GM', name: 'Gambia' },
  { id: '80', abbrv: 'GE', name: 'Georgia' },
  { id: '81', abbrv: 'DE', name: 'Germany' },
  { id: '82', abbrv: 'GH', name: 'Ghana' },
  { id: '83', abbrv: 'GI', name: 'Gibraltar' },
  { id: '84', abbrv: 'GR', name: 'Greece' },
  { id: '85', abbrv: 'GL', name: 'Greenland' },
  { id: '86', abbrv: 'GD', name: 'Grenada' },
  { id: '87', abbrv: 'GP', name: 'Guadeloupe' },
  { id: '88', abbrv: 'GU', name: 'Guam' },
  { id: '89', abbrv: 'GT', name: 'Guatemala' },
  { id: '90', abbrv: 'GN', name: 'Guinea' },
  { id: '91', abbrv: 'GW', name: 'Guinea-Bissau' },
  { id: '92', abbrv: 'GY', name: 'Guyana' },
  { id: '93', abbrv: 'HT', name: 'Haiti' },
  { id: '94', abbrv: 'HM', name: 'Heard and McDonald Islands' },
  { id: '95', abbrv: 'HN', name: 'Honduras' },
  { id: '96', abbrv: 'HK', name: 'Hong Kong' },
  { id: '97', abbrv: 'HU', name: 'Hungary' },
  { id: '98', abbrv: 'IS', name: 'Iceland' },
  { id: '99', abbrv: 'IN', name: 'India' },
  { id: '100', abbrv: 'ID', name: 'Indonesia' },
  { id: '101', abbrv: 'IQ', name: 'Iraq' },
  { id: '102', abbrv: 'IE', name: 'Ireland' },
  { id: '103', abbrv: 'IR', name: 'Islamic Republic of Iran' },
  { id: '104', abbrv: 'IL', name: 'Israel' },
  { id: '105', abbrv: 'IT', name: 'Italy' },
  { id: '106', abbrv: 'JM', name: 'Jamaica' },
  { id: '107', abbrv: 'JP', name: 'Japan' },
  { id: '108', abbrv: 'JO', name: 'Jordan' },
  { id: '109', abbrv: 'KZ', name: 'Kazakhstan' },
  { id: '110', abbrv: 'KE', name: 'Kenya' },
  { id: '111', abbrv: 'KI', name: 'Kiribati' },
  { id: '112', abbrv: 'KP', name: 'Korea, Dem. Peoples Rep of' },
  { id: '113', abbrv: 'KR', name: 'Korea, Republic of' },
  { id: '114', abbrv: 'KW', name: 'Kuwait' },
  { id: '115', abbrv: 'KG', name: 'Kyrgyzstan' },
  { id: '116', abbrv: 'LA', name: 'Laos' },
  { id: '117', abbrv: 'LV', name: 'Latvia' },
  { id: '118', abbrv: 'LB', name: 'Lebanon' },
  { id: '119', abbrv: 'LS', name: 'Lesotho' },
  { id: '120', abbrv: 'LR', name: 'Liberia' },
  { id: '121', abbrv: 'LY', name: 'Libyan Arab Jamahiriya' },
  { id: '122', abbrv: 'LI', name: 'Liechtenstein' },
  { id: '123', abbrv: 'LT', name: 'Lithuania' },
  { id: '124', abbrv: 'LU', name: 'Luxembourg' },
  { id: '125', abbrv: 'MO', name: 'Macau' },
  { id: '126', abbrv: 'MK', name: 'Macedonia' },
  { id: '127', abbrv: 'MG', name: 'Madagascar' },
  { id: '128', abbrv: 'MW', name: 'Malawi' },
  { id: '129', abbrv: 'MY', name: 'Malaysia' },
  { id: '130', abbrv: 'MV', name: 'Maldives' },
  { id: '131', abbrv: 'ML', name: 'Mali' },
  { id: '132', abbrv: 'MT', name: 'Malta' },
  { id: '133', abbrv: 'MH', name: 'Marshall Islands' },
  { id: '134', abbrv: 'MQ', name: 'Martinique' },
  { id: '135', abbrv: 'MR', name: 'Mauritania' },
  { id: '136', abbrv: 'MU', name: 'Mauritius' },
  { id: '137', abbrv: 'YT', name: 'Mayotte' },
  { id: '138', abbrv: 'MX', name: 'Mexico' },
  { id: '139', abbrv: 'FM', name: 'Micronesia' },
  { id: '140', abbrv: 'MD', name: 'Moldova, Republic of' },
  { id: '141', abbrv: 'MC', name: 'Monaco' },
  { id: '142', abbrv: 'MN', name: 'Mongolia' },
  { id: '143', abbrv: 'MS', name: 'Montserrat' },
  { id: '144', abbrv: 'MA', name: 'Morocco' },
  { id: '145', abbrv: 'MZ', name: 'Mozambique' },
  { id: '146', abbrv: 'MM', name: 'Myanmar' },
  { id: '147', abbrv: 'NA', name: 'Namibia' },
  { id: '148', abbrv: 'NR', name: 'Nauru' },
  { id: '149', abbrv: 'NP', name: 'Nepal' },
  { id: '150', abbrv: 'NL', name: 'Netherlands' },
  { id: '151', abbrv: 'AN', name: 'Netherlands Antilles' },
  { id: '152', abbrv: 'NC', name: 'New Caledonia' },
  { id: '153', abbrv: 'NZ', name: 'New Zealand' },
  { id: '154', abbrv: 'NI', name: 'Nicaragua' },
  { id: '155', abbrv: 'NE', name: 'Niger' },
  { id: '156', abbrv: 'NG', name: 'Nigeria' },
  { id: '157', abbrv: 'NU', name: 'Niue' },
  { id: '158', abbrv: 'NF', name: 'Norfolk Island' },
  { id: '159', abbrv: 'MP', name: 'Northern Mariana Islands' },
  { id: '160', abbrv: 'NO', name: 'Norway' },
  { id: '161', abbrv: 'OM', name: 'Oman' },
  { id: '162', abbrv: 'PK', name: 'Pakistan' },
  { id: '163', abbrv: 'PW', name: 'Palau' },
  { id: '164', abbrv: 'PA', name: 'Panama' },
  { id: '165', abbrv: 'PG', name: 'Papua New Guinea' },
  { id: '166', abbrv: 'PY', name: 'Paraguay' },
  { id: '167', abbrv: 'PE', name: 'Peru' },
  { id: '168', abbrv: 'PH', name: 'Philippines' },
  { id: '169', abbrv: 'PN', name: 'Pitcairn' },
  { id: '170', abbrv: 'PL', name: 'Poland' },
  { id: '171', abbrv: 'PT', name: 'Portugal' },
  { id: '172', abbrv: 'PR', name: 'Puerto Rico' },
  { id: '173', abbrv: 'QA', name: 'Qatar' },
  { id: '174', abbrv: 'RE', name: 'Reunion' },
  { id: '175', abbrv: 'RO', name: 'Romania' },
  { id: '176', abbrv: 'RU', name: 'Russian Federation' },
  { id: '177', abbrv: 'RW', name: 'Rwanda' },
  { id: '178', abbrv: 'LC', name: 'Saint Lucia' },
  { id: '179', abbrv: 'WS', name: 'Samoa' },
  { id: '180', abbrv: 'SM', name: 'San Marino' },
  { id: '181', abbrv: 'ST', name: 'Sao Tome and Principe' },
  { id: '182', abbrv: 'SA', name: 'Saudi Arabia' },
  { id: '183', abbrv: 'SN', name: 'Senegal' },
  { id: '184', abbrv: 'RS', name: 'Republic of Serbia' },
  { id: '185', abbrv: 'SC', name: 'Seychelles' },
  { id: '186', abbrv: 'SL', name: 'Sierra Leone' },
  { id: '187', abbrv: 'SG', name: 'Singapore' },
  { id: '188', abbrv: 'SK', name: 'Slovakia' },
  { id: '189', abbrv: 'SI', name: 'Slovenia' },
  { id: '190', abbrv: 'SB', name: 'Solomon Islands' },
  { id: '191', abbrv: 'SO', name: 'Somalia' },
  { id: '192', abbrv: 'ZA', name: 'South Africa' },
  { id: '193', abbrv: 'ES', name: 'Spain' },
  { id: '194', abbrv: 'LK', name: 'Sri Lanka' },
  { id: '195', abbrv: 'SH', name: 'St. Helena' },
  { id: '196', abbrv: 'KN', name: 'St. Kitts and Nevis' },
  { id: '197', abbrv: 'PM', name: 'St. Pierre and Miquelon' },
  { id: '198', abbrv: 'VC', name: 'St. Vincent and the Grenadines' },
  { id: '199', abbrv: 'SD', name: 'Sudan' },
  { id: '200', abbrv: 'SR', name: 'Suriname' },
  { id: '201', abbrv: 'SJ', name: 'Svalbard and Jan Mayen Islands' },
  { id: '202', abbrv: 'SZ', name: 'Swaziland' },
  { id: '203', abbrv: 'SE', name: 'Sweden' },
  { id: '204', abbrv: 'CH', name: 'Switzerland' },
  { id: '205', abbrv: 'SY', name: 'Syrian Arab Republic' },
  { id: '206', abbrv: 'TW', name: 'Taiwan' },
  { id: '207', abbrv: 'TJ', name: 'Tajikistan' },
  { id: '208', abbrv: 'TZ', name: 'Tanzania, United Republic of' },
  { id: '209', abbrv: 'TH', name: 'Thailand' },
  { id: '210', abbrv: 'TG', name: 'Togo' },
  { id: '211', abbrv: 'TK', name: 'Tokelau' },
  { id: '212', abbrv: 'TO', name: 'Tonga' },
  { id: '213', abbrv: 'TT', name: 'Trinidad and Tobago' },
  { id: '214', abbrv: 'TN', name: 'Tunisia' },
  { id: '215', abbrv: 'TR', name: 'Turkey' },
  { id: '216', abbrv: 'TM', name: 'Turkmenistan' },
  { id: '217', abbrv: 'TC', name: 'Turks and Caicos Islands' },
  { id: '218', abbrv: 'TV', name: 'Tuvalu' },
  { id: '219', abbrv: 'UG', name: 'Uganda' },
  { id: '220', abbrv: 'UA', name: 'Ukraine' },
  { id: '221', abbrv: 'AE', name: 'United Arab Emirates' },
  { id: '222', abbrv: 'GB', name: 'United Kingdom (GB)' },
  { id: '223', abbrv: 'US', name: 'United States' },
  { id: '224', abbrv: 'VI', name: 'United States Virgin Islands' },
  { id: '225', abbrv: 'UY', name: 'Uruguay' },
  { id: '226', abbrv: 'UZ', name: 'Uzbekistan' },
  { id: '227', abbrv: 'VU', name: 'Vanuatu' },
  { id: '228', abbrv: 'VA', name: 'Vatican City State' },
  { id: '229', abbrv: 'VE', name: 'Venezuela' },
  { id: '230', abbrv: 'VN', name: 'Vietnam' },
  { id: '231', abbrv: 'WF', name: 'Wallis And Futuna Islands' },
  { id: '232', abbrv: 'EH', name: 'Western Sahara' },
  { id: '233', abbrv: 'YE', name: 'Yemen' },
  { id: '234', abbrv: 'ZR', name: 'Zaire' },
  { id: '235', abbrv: 'ZM', name: 'Zambia' },
  { id: '236', abbrv: 'ZW', name: 'Zimbabwe' },
  { id: '1653', abbrv: 'ME', name: 'Montenegro' },
];
